import LoadingCommon from './loading-common.vue';
export default LoadingCommon;